export var tableheadData = [{
		title: "单据号",
		prop: "danjh",
		width: "160",
		align: "left"

	},
	{
		title: "单据状态",
		prop: "fapzt",
		custom: true,
		width: "100"
	},
	{
		title: "发票种类",
		prop: "fapzl",
		issort: true,
		custom: true,
		width: "100"
	},
	{
		title: "特殊业务",
		prop: "tedywlx",
		issort: true,
		custom: true,
		width: "100"
	},
	{
		title: "发票类型",
		prop: "faplxdm",
		issort: true,
		custom: true,
		width: "100"
	},
	{
		title: "发票代码",
		prop: "fapdm",
		issort: true,
		width: "160",
		align: "left"
	},
	{
		title: "发票号码",
		prop: "faphm",
		custom: true,
		issort: true,
		width: "160",
		align: "left"
	},
	{
		title: "购方名称",
		prop: "goufmc",
		width: "160",
		align: "left"
	},
	{
		title: "金额",
		prop: "hejje",
		width: "100",
		AmountFormat: true,
		align: "right"
	},
	{
		title: "税额",
		prop: "hejse",
		width: "100",
		AmountFormat: true,
		align: "right"
	},

	{
		title: "开票日期",
		prop: "kaiprq",
		width: "160",
		align: "left",
		custom: true,
	},
	{
		title: "创建日期",
		prop: "chuangjrq",
		issort: true,
		custom: true,
		width: "160",
		align: "left"
	},
	{
		title: "打印状态",
		prop: "dayzt",
		custom: true,
		width: "100"
	},
	{
		title: "是否清单",
		prop: "hasList",
		custom: true,
		width: "100"
	},

	{
		title: "是否负数",
		prop: "kaiplx",
		custom: true,
		width: "100"
	},


	{
		title: "清单打印状态",
		prop: "qingddyzt",
		custom: true,
		width: "100"
	},
	{
		title: "递送状态",
		prop: "diszt",
		custom: true,
		width: "100"
	},
	{
		title: "原发票代码",
		prop: "yuanfpdm",
		width: "160",
		align: "left"
	},
	{
		title: "原发票号码",
		prop: "yuanfphm",
		width: "160",
		align: "left"
	}, {
		title: "制单人",
		prop: "zhidr",
		width: "100"
	}, {
		title: "申请人",
		prop: "shenqr",
		width: "100"
	}, {
		title: "自定义说明",
		prop: "zidysm",
		width: "160",
		align: "left"
	}, {
		title: "税盘编号",
		prop: "kaipzddm",
		width: "160",
		align: "left"
	}
]
